const SYSTEM_TYPE_LABELS: Record<string, string> = {
  conversacional: 'Conversacional',
  analisisExtraccion: 'Análisis y extracción',
  recomendacionPersonalizacion: 'Recomendación y personalización',
  predictivoDecision: 'Predictivo / toma de decisión',
  automatizacion: 'Automatización',
  deteccionSupervision: 'Detección y supervisión',
  criticoSensible: 'Crítico o sensible',
  otros: 'Otros',
};

export function mapSystemTypeLabel(value: string): string {
  return SYSTEM_TYPE_LABELS[value] ?? value;
}
